(() => {
  const focusable = root => [...root.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),summary')].filter(el => el.getClientRects().length);
  const close = (details, restore = false) => {
    details.querySelectorAll('details[open]').forEach(el => el.open = false);
    details.open = false;
    if (restore) details.querySelector(':scope > summary')?.focus();
  };
  const syncRows = () => document.querySelectorAll('[data-we-scroll]').forEach(button => {
    const row = document.getElementById(button.dataset.target);
    if (!row) return;
    const end = row.scrollWidth - row.clientWidth;
    button.disabled = Number(button.dataset.weScroll) < 0 ? row.scrollLeft < 2 : row.scrollLeft >= end - 2;
    if (!row.dataset.weBound) {
      row.dataset.weBound = 'true';
      row.addEventListener('scroll', syncRows, {passive:true});
    }
  });
  const syncHeader = () => {
    const header = document.querySelector('.we-header');
    if (header) document.documentElement.style.setProperty('--we-menu-top', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
  };
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const button = target.closest('[data-we-scroll]');
    if (button) {
      const row = document.getElementById(button.dataset.target);
      row?.scrollBy({left:Number(button.dataset.weScroll) * row.clientWidth * .8, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    const dismiss = target.closest('[data-we-menu-close]');
    if (dismiss) close(dismiss.closest('.we-mobile-menu'), true);
    const mobileLink = target.closest('.we-mobile-menu a');
    if (mobileLink) close(mobileLink.closest('.we-mobile-menu'));
    document.querySelectorAll('.we-header details[open]').forEach(details => {
      if (!details.contains(target)) close(details);
    });
  });
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.closest('.we-header')) return;
    if (details.open) {
      syncHeader();
      [...details.parentElement.children].filter(el => el instanceof HTMLDetailsElement && el !== details).forEach(el => close(el));
    }
  }, true);
  document.addEventListener('keydown', event => {
    const active = document.activeElement;
    const mobile = document.querySelector('.we-mobile-menu[open]');
    if (event.key === 'Escape') {
      const nested = active?.closest('.we-header details[open]');
      const opened = nested || document.querySelector('.we-header details[open]');
      if (opened) {event.preventDefault(); close(opened, true);}
      return;
    }
    if (event.key === 'Tab' && mobile) {
      const controls = focusable(mobile);
      const first = controls[0], last = controls.at(-1);
      if (event.shiftKey && active === first) {event.preventDefault(); last?.focus();}
      else if (!event.shiftKey && active === last) {event.preventDefault(); first?.focus();}
    }
    if (['ArrowDown','ArrowUp'].includes(event.key)) {
      const group = active?.closest('.we-nav-group');
      if (!group) return;
      event.preventDefault();
      group.open = true;
      const links = focusable(group).filter(el => el !== group.querySelector(':scope > summary'));
      const at = links.indexOf(active);
      const next = at < 0 ? (event.key === 'ArrowDown' ? 0 : links.length - 1) : (at + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
      links[next]?.focus();
    }
  });
  document.addEventListener('focusin', event => {
    if (!event.target.closest('.we-header')) document.querySelectorAll('.we-nav details[open]').forEach(el => close(el));
  });
  window.addEventListener('resize', () => {
    syncHeader();syncRows();
    if (matchMedia('(min-width:1100px)').matches) document.querySelectorAll('.we-mobile-menu[open]').forEach(el => close(el));
  }, {passive:true});
  document.addEventListener('shopify:section:load', () => {syncRows();syncHeader();});
  syncRows();syncHeader();
})();
